import { TableData } from "../../types";

/**
 * Builds searchable-select options from patient Dx table rows.
 *
 * @param tableData - Patient Dx rows shown in the modal table.
 * @return Dropdown options with ICD code value and code-description label.
 */
export const dropdownOptions = (tableData: TableData[]) =>
  tableData.map((entry) => ({
    value: entry.icd10_code || "",
    label: `${entry.icd10_code || ""} - ${entry.icd10_desc || ""}`,
  }));
